import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5060075f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-group-item" }

import { ref, watch } from 'vue';
import draggable from 'vuedraggable';

/* eslint-disable */ 

export default /*#__PURE__*/_defineComponent({
  __name: 'TableDraggableComponent',
  props: {
    items: {},
    rowClassProcessor: { type: Function }
  },
  emits: ["update:items", "reordered"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

/* eslint-disable */
const emit = __emit;

const internalItems = ref([...props.items]);

watch(
	() => props.items, 
	(newVal) => internalItems.value = [...newVal], { deep: true }
);

const onDragEnd = () => {
	const _tems = [...internalItems.value];
  emit('update:items', _tems);
  emit('reordered', _tems);
};

const rowClassProcessorInvoker = (item: any, itemIndex: number) => {
	if (typeof props.rowClassProcessor === 'function') {
		return props.rowClassProcessor(item, itemIndex);
	}	
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(draggable), {
    modelValue: internalItems.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalItems).value = $event)),
    tag: "tbody",
    "item-key": "id",
    class: "list-group",
    "ghost-class": "ghost",
    onEnd: onDragEnd
  }, {
    item: _withCtx(({ element, index }) => [
      _createElementVNode("tr", {
        class: _normalizeClass(rowClassProcessorInvoker(element, index))
      }, [
        _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps({ element, index })), () => [
          _createElementVNode("td", _hoisted_1, " element '" + _toDisplayString(element) + "', index: " + _toDisplayString(index), 1)
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})